import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';

const DIMS = [
  { key: 'length', label: 'Length', placeholder: 'e.g. 7ft / 84in / 2130mm' },
  { key: 'width', label: 'Width', placeholder: 'e.g. 3ft / 36in / 915mm' },
  { key: 'depth', label: 'Depth', placeholder: 'e.g. 3in / 75mm' }
];

const OptionBlock = ({ title, description, prefix, checked, onToggle, formData, setFormData }) => (
  <div className={`rounded-lg border transition-colors ${checked ? 'border-cyan-400 bg-white' : 'border-cyan-200 bg-cyan-50/50'}`}>
    <label className="flex items-center gap-3 p-4 cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onToggle(e.target.checked)}
        className="w-5 h-5 rounded border-cyan-400 text-cyan-600 focus:ring-cyan-500"
        data-testid={`${prefix}-checkbox`}
      />
      <div>
        <span className="font-medium text-cyan-900">{title}</span>
        <p className="text-xs text-cyan-700">{description}</p>
      </div>
    </label>
    {checked && (
      <div className="px-4 pb-4 grid grid-cols-1 sm:grid-cols-3 gap-3" data-testid={`${prefix}-dimensions`}>
        {DIMS.map(({ key, label, placeholder }) => (
          <div key={key} className="space-y-1">
            <Label htmlFor={`${prefix}_${key}`} className="text-cyan-800">{label}</Label>
            <Input
              id={`${prefix}_${key}`}
              value={formData[`${prefix}_${key}`] || ''}
              onChange={(e) => setFormData({ ...formData, [`${prefix}_${key}`]: e.target.value })}
              placeholder={placeholder}
              className="border-cyan-200 focus:ring-cyan-500"
              data-testid={`${prefix}-${key}-input`}
            />
          </div>
        ))}
      </div>
    )}
  </div>
);

export default function KerbCoverSlabSection({ formData, setFormData }) {
  return (
    <div className="pt-4 border-t border-slate-200 space-y-3" data-testid="kerb-cover-slab-section">
      <div>
        <h4 className="font-semibold text-slate-800">Kerb Surround & Cover Slab</h4>
        <p className="text-xs text-slate-500 mt-0.5">Optional extras — tick to add and enter the dimensions</p>
      </div>
      <OptionBlock
        title="Kerb Surround"
        description="Kerb set surrounding the grave"
        prefix="kerb"
        checked={!!formData.kerb_surround}
        onToggle={(v) => setFormData({ ...formData, kerb_surround: v })}
        formData={formData}
        setFormData={setFormData}
      />
      <OptionBlock
        title="Cover Slab"
        description="Slab covering the area inside the kerbs"
        prefix="cover_slab"
        checked={!!formData.cover_slab}
        onToggle={(v) => setFormData({ ...formData, cover_slab: v })}
        formData={formData}
        setFormData={setFormData}
      />
    </div>
  );
}
